import { apiFetch, ApiError } from './client'
import { queueResponseSchema, type QueueResponse } from '@/lib/schemas/queue'

/** GET /api/queue — all KH orders needing a decision, server-sorted newest first. */
export async function getQueue(): Promise<QueueResponse> {
  const res = await apiFetch('/api/queue', { method: 'GET' })
  if (!res.ok) {
    const detail = await readDetail(res)
    throw new ApiError(res.status, detail ?? `Failed to load queue (${res.status})`, detail)
  }
  return queueResponseSchema.parse(await res.json())
}

async function readDetail(res: Response): Promise<string | undefined> {
  try {
    const body = (await res.json()) as { detail?: string }
    return body?.detail
  } catch {
    return undefined
  }
}
